import { createFileRoute } from '@tanstack/react-router';

import { config } from '@/constants/config';

export const Route = createFileRoute('/(landing)/privacy')({
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <div className="container mx-auto max-w-3xl px-4 py-12">
      <h1 className="mb-8 text-3xl font-bold">Política de Privacidade</h1>

      <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6">
        <p className="text-muted-foreground">
          Última atualização: {new Date().toLocaleDateString('pt-BR')}
        </p>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">1. Introdução</h2>
          <p>
            A eumimo (&quot;nós&quot;, &quot;nosso&quot; ou &quot;empresa&quot;)
            está comprometida em proteger sua privacidade. Esta Política de
            Privacidade explica como coletamos, usamos, divulgamos e protegemos
            suas informações quando você utiliza nosso aplicativo e serviços.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">
            2. Informações que Coletamos
          </h2>
          <p>Coletamos os seguintes tipos de informações:</p>
          <ul className="list-inside list-disc space-y-2">
            <li>
              <strong>Informações de cadastro:</strong> nome, email e
              informações do perfil que você nos fornece voluntariamente.
            </li>
            <li>
              <strong>Dados de uso:</strong> informações sobre como você
              interage com nosso aplicativo, incluindo listas de desejos e datas
              comemorativas.
            </li>
            <li>
              <strong>Informações técnicas:</strong> dados de dispositivo,
              endereço IP e cookies para melhorar sua experiência.
            </li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">
            3. Como Usamos suas Informações
          </h2>
          <p>Utilizamos suas informações para:</p>
          <ul className="list-inside list-disc space-y-2">
            <li>Fornecer, manter e melhorar nossos serviços</li>
            <li>
              Permitir que você compartilhe sua lista de desejos com seu
              parceiro(a)
            </li>
            <li>Enviar notificações sobre datas comemorativas</li>
            <li>Processar pagamentos (para assinantes Pro)</li>
            <li>
              Comunicar atualizações importantes sobre o serviço, quando
              necessário
            </li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">
            4. Compartilhamento de Dados
          </h2>
          <p>
            <strong>Não vendemos seus dados pessoais.</strong> Suas listas de
            desejos são compartilhadas apenas com o parceiro(a) que você
            convidar para o eumimo.
          </p>
          <p>
            Podemos compartilhar informações com prestadores de serviço que nos
            auxiliam na operação do aplicativo (como processadores de
            pagamento), sempre sob rigorosos acordos de confidencialidade.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">5. Segurança dos Dados</h2>
          <p>
            Implementamos medidas de segurança técnicas e organizacionais para
            proteger suas informações, incluindo:
          </p>
          <ul className="list-inside list-disc space-y-2">
            <li>Criptografia de dados em trânsito (HTTPS/TLS)</li>
            <li>Autenticação segura por email (passwordless)</li>
            <li>Acesso restrito aos dados por funcionários autorizados</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">6. Seus Direitos</h2>
          <p>
            De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem
            direito a:
          </p>
          <ul className="list-inside list-disc space-y-2">
            <li>Acessar seus dados pessoais</li>
            <li>Corrigir dados incompletos ou desatualizados</li>
            <li>Solicitar a exclusão de seus dados</li>
            <li>Revogar o consentimento a qualquer momento</li>
            <li>Solicitar a portabilidade dos seus dados</li>
          </ul>
          <p>
            Para exercer esses direitos, entre em contato conosco pelo email
            indicado abaixo.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">7. Retenção de Dados</h2>
          <p>
            Mantemos seus dados enquanto sua conta estiver ativa. Ao solicitar a
            exclusão da conta, seus dados serão removidos em até 30 dias, exceto
            quando necessário para cumprimento de obrigações legais.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">8. Cookies</h2>
          <p>
            Utilizamos cookies essenciais para o funcionamento do aplicativo,
            como manter sua sessão ativa. Não utilizamos cookies de rastreamento
            de terceiros para publicidade.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">
            9. Alterações nesta Política
          </h2>
          <p>
            Podemos atualizar esta Política de Privacidade periodicamente.
            Notificaremos você sobre mudanças significativas por email ou
            através do aplicativo.
          </p>
        </section>

        <section className="space-y-4">
          <h2 className="text-xl font-semibold">10. Contato</h2>
          <p>
            Se você tiver dúvidas sobre esta Política de Privacidade ou sobre
            como tratamos seus dados, entre em contato:
          </p>
          <p>
            <strong>Email:</strong> {config.company.email}
            <br />
            <strong>CNPJ:</strong> {config.company.cnpj}
          </p>
        </section>
      </div>
    </div>
  );
}
